//#region src/core/ui/captions-button/data.ts
const CaptionsButtonDataAttrs = {
	/** Present when captions are enabled. */
	subtitlesShowing: "data-active",
	/** Indicates captions availability (`available` or `unavailable`). */
	availability: "data-availability",
	/** Present when the button is non-interactive (mirrors `aria-disabled`). */
	disabled: "data-disabled",
	/** Present when the button is hidden because no caption tracks are present. */
	hidden: "data-hidden"
};
//#endregion
export { CaptionsButtonDataAttrs };

//# sourceMappingURL=data.js.map